import { render, staticRenderFns } from "./AccountChildChangeBindDialog.vue?vue&type=template&id=1642bc6c&scoped=true"
import script from "./AccountChildChangeBindDialog.vue?vue&type=script&lang=ts"
export * from "./AccountChildChangeBindDialog.vue?vue&type=script&lang=ts"
import style0 from "./AccountChildChangeBindDialog.vue?vue&type=style&index=0&id=1642bc6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642bc6c",
  null
  
)

export default component.exports